import React from "react";
import Preloader from "../../Global/Preloader";
import Header from "../../Global/Header";
import BredCrumb from "../../Global/BredCrumb";
import BlogSection from "../MenBlogList/BlogSection";
import Call from "../../Menhomeone/Call";
import Footer from "../../Global/Footer";
import GoToTop from "../../Global/GoToTop";

const Main =()=> {
    return(
        <>
        <Preloader/>
        <Header/>
        <BredCrumb Title="Latest Blog Post" subtitle="Blog List" />
        <div className="page_wrapper">
        <BlogSection/>
        <Call/>
        <Footer/>
        <GoToTop/>


        </div>
        </>
    )
}
export default Main;